export const productGallery = () => {
    document.addEventListener('DOMContentLoaded', () => {productGallery

        // No.27
        document.addEventListener("click", function (event) {
            var target = event.target;
            if (target.matches('scroll-carousel.is-scrollable .product-gallery__media[data-media-type="image"] img')) {
                target.dispatchEvent(new CustomEvent("lightbox:open", {bubbles: true}))
            }
        });

        // No.42
        var panelWrapElement;
        var ProductGalleryPanel = class extends HTMLElement {

            constructor(){
                super();

                var self = this;
                panelWrapElement = this.querySelector(".product-gallery-panel-wrap");

                this.button.addEventListener("click", this.onPanelOpen, true);
                this.buttonClose.addEventListener("click", this.onPanelClose, true);

                var updateGalleryTimer = setInterval(function(){
                    if(self.scrollCarousel != undefined){
                        self.setImagesFormGallery(self);
                        clearInterval(updateGalleryTimer);
                    }
                }, 500);

                document.addEventListener('variant:change', function(){
                    setTimeout(function(){
                        self.setImagesFormGallery(self);
                    }, 300)
                });
            }
            connectedCallback() {

            }

            onPanelOpen(event){
                panelWrapElement.classList.add("show");
                document.documentElement.classList.add("overflow-y");
            }

            onPanelClose(event){
                panelWrapElement.classList.remove("show");
                document.documentElement.classList.remove("overflow-y");
            }

            onZoomImage(event){
                var index = parseInt(this.getAttribute('data-index'));
                event.target.dispatchEvent(new CustomEvent("lightbox:open", {bubbles: true, detail: {index}}))
            }

            setImagesFormGallery = function(self){
                self.panelGalleryList.innerHTML = '';
                self.scrollCarousel.querySelectorAll(".product-gallery__media").forEach(function(element, index){
                    if(element.getAttribute('data-media-type') == 'image'){
                        var itemHtml = '<div class="image-item" data-index="' + index + '">' +
                                            '<div class="ratio-100">' +
                                                '<img src="' + element.querySelector("img").getAttribute('src') + '" />' + 
                                            '</div>' + 
                                        '</div>';
                        self.panelGalleryList.insertAdjacentHTML('beforeend', itemHtml);
                    }
                    self.imageItems.forEach(function(img){
                        img.addEventListener("click", self.onZoomImage);
                    });
                })
            }

            get button() {
                return this.querySelector('button.product-gallery__open-popup');
            }
            get buttonClose() {
                return this.querySelector(".panel-back");
            }
            get panelGalleryList(){
                return this.querySelector('.list-gallery-images');
            }
            get scrollCarousel(){
                return document.querySelector(".product-gallery__carousel.is-scrollable");
            }
            get imageItems(){
                return this.querySelectorAll('.image-item');
            }
        }

        if (!window.customElements.get("product-gallery-panel")) {
            window.customElements.define("product-gallery-panel", ProductGalleryPanel);
        }

        // No.43
        function addLastSlide() {
            var scrollCarousel = document.querySelector('scroll-carousel');
            var imgFirst = scrollCarousel.firstElementChild.innerHTML;
            var lastItemHtml = '<div class="product-gallery__media snap-center gallery-last-item">' +
                                    '<div class="last-info">' + 
                                        // '<h3 class="title">' + window.themeVariables.strings.lastGalleryItemTitle + '</h3>' + 
                                        '<a class="btn-to-similar" href="#"><span class="text">' + window.themeVariables.strings.lastGalleryItemButtonName + '</span><span class="icon iia-chevron iia-chevron-down"> </span></a>' +
                                    '</div>' + 
                                    '<div class="img-wrap">' + imgFirst + '</div>' + 
                                '</div>';
            scrollCarousel.insertAdjacentHTML('beforeend', lastItemHtml);
            var firstItem = '<div class="product-gallery__media snap-center gallery-first-item">' + 
                                    '<div class="img-wrap">' + imgFirst + '</div>' + 
                                '</div>';
            scrollCarousel.insertAdjacentHTML('beforeend', firstItem);
            let productGallery = document.querySelector("product-gallery");
            "function" == typeof productGallery?.connectedCallback && productGallery.connectedCallback();

            var carouselNavigation =  document.querySelector("carousel-navigation.page-dots");
            carouselNavigation.insertAdjacentHTML('beforeend', '<button type="button" class="tap-area last-dot" aria-current="false" data-index="' + carouselNavigation.querySelectorAll('button').length + '"><span class="sr-only"></span></button>');

            //Scroll to related products
            var relatedProducts = document.querySelector(".shopify-section--related-products");
                if(relatedProducts){
                document.querySelector(".btn-to-similar").addEventListener("click", function(e){
                    e.preventDefault();
                    relatedProducts.scrollIntoView({
                        block: "start",
                        behavior: 'smooth'
                    });

                    setTimeout(function(){
                        //Reset carousel
                        scrollCarousel.select(0);
                    }, 1000);

                });
            }

            scrollCarousel.addEventListener('carousel:settle', function(e){
                if(e.detail.cell.className == "product-gallery__media snap-center gallery-first-item"){
                    scrollCarousel.select(0, { instant: true })
                }
            })

            var lastItem = carouselNavigation.querySelector('button[data-index="' + (carouselNavigation.querySelectorAll('button').length - 1) + '"]');
            if(lastItem){
                scrollCarousel.addEventListener('carousel:change', function(event) {
                    var index = event.detail.index;
                    if((carouselNavigation.querySelectorAll('button').length - 1) == index){
                        lastItem.setAttribute('aria-current', 'true');
                    }else{
                        lastItem.setAttribute('aria-current', 'false');
                    }
                })

                lastItem.addEventListener("click", function(e){
                    var index = this.getAttribute('data-index');
                    scrollCarousel.select(index);
                })

            }
        }

        var lastSlideTimer = setInterval(function(){
            if(document.querySelector('.product-gallery scroll-carousel.is-scrollable')){
                requestAnimationFrame(addLastSlide);
                clearInterval(lastSlideTimer);
            }
        }, 100);

        document.addEventListener('variant:change', function(event) {
            setTimeout(function(){
                requestAnimationFrame(addLastSlide);
            }, 500);
        })

    })
}